import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErbsComponent } from './erbs/erbs.component';
import { MonitoringComponent } from './monitoring/monitoring.component';
import { ReportComponent } from './report/report.component';
import { TranslateMaxtrackComponent } from './translate-maxtrack/translate-maxtrack.component';
import { UtilsComponent } from './utils/utils.component';
import { MapComponent } from './map/map.component';
import { CommandInfoComponent } from './command-info/command-info.component';
import { ProcessAutoComponent } from './process-auto/process-auto.component';
import { ProcessFlowComponent } from './process-flow/process-flow.component';

const routes: Routes = [
  {
    path: 'map',
    component: MapComponent,
  },
  {
    path: 'monitoring',
    component: MonitoringComponent,
  },
  {
    path: 'translateMaxtrack',
    component: TranslateMaxtrackComponent,
  },
  {
    path: 'erbs',
    component: ErbsComponent,
  },
  {
    path: 'report',
    component: ReportComponent,
  },
  {
    path: 'utils',
    component: UtilsComponent,
  },
  {
    path: 'commandInfo',
    component: CommandInfoComponent,
  },
  {
    path: 'processAuto',
    component: ProcessAutoComponent,
  },
  {
    path: 'processFlow',
    component: ProcessFlowComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ToolsRoutingModule {}
